const fontSize = {
  fs10: '10px',
  fs12: '12px',
  fs14: '14px',
  fs16: '16px',
  fs22: '22px'
}

export default fontSize